import request from '@/utils/request'

export function verify (customerName, customerSSN1, customerSSN2) {
    let customerSSN = `${customerSSN1}-${customerSSN2}`
    let requestBody = {
        ppCd: customerName, //PK
        ppNm: customerName,
        ppDscr: customerSSN,
        ppDivsCd: '',
        ppGrpCd: '',
        ppGrpNm: '',
    }
    return request({
        url: `/ococ/metadata/v1/pricePlan`,
        method: 'post',
        data: requestBody
    })
}

export function getTermConditionList() {
    return request({
        url: `/ococ/metadata/v1/agreements`,
        method: 'get'
    })
}

export function getComCodeList(cmmCdGrpId) {
    let params = {
        cmmCdGrpId: cmmCdGrpId
    }
    return request({
        url: `/ococ/datacapture/v1/commonCodes`,
        method: 'get',
        params
    })
}

export function getDeviceList() {
    let params = {
        useYn: 'Y'
    }
    return request({
        url: `/ococ/metadata/v1/devices`,
        method: 'get',
        params
    })
}

export function getPricePlan(ppCd) {
    return request({
        url: `/ococ/datacapture/v1/pricePlans/${ppCd}`,
        method: 'get'
    })
}